import { render, staticRenderFns } from "./CatalogEditor.vue?vue&type=template&id=8a0844b4&scoped=true"
import script from "./CatalogEditor.vue?vue&type=script&lang=js"
export * from "./CatalogEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0844b4",
  null
  
)

export default component.exports